import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
// Initialize Firebase
var config = {
  apiKey: "AIzaSyB1i9w-TJHEMyaeDGqsaJsfOvSp6Fd0O58",
  authDomain: "dev-app-137723.firebaseapp.com",
  databaseURL: "https://dev-app-137723.firebaseio.com",
  projectId: "dev-app-137723",
  storageBucket: "clientphotos",
  messagingSenderId: "459070776444"
};

const firebaseApp = firebase.initializeApp(config);
const auth = firebase.auth();
const functions = firebase.functions();

firebaseApp.firestore().settings({});
export default firebaseApp.firestore();
